import React from 'react';
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Modal } from 'react-bootstrap';
import moment from 'moment-timezone';
import { EntityIcon } from '../Entity';
import { DataTypeDisplayValue } from '../DataTypeDisplayValue';
import DeviceViewDetailsGraph from '../Common/device_view_details_graph';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faChartArea from '@fortawesome/fontawesome-free-solid/faChartArea';
import { Popover, OverlayTrigger } from 'react-bootstrap';
import { ScrollModule } from "../ScrollModule"
import ScrollArea from "react-scrollbar";
import { DeviceDataOverrideService, TimeFormattingService } from '../../services';
import { Map, TileLayer, Marker } from "react-leaflet";

import { MultiRowSelection } from '../MultiRowSelection';
import { DatePickerInput } from '../DatePickerInput';

import ReactTable from "react-table";
import "react-table/react-table.css";
import i18next from "i18next";
import { EntityDetailModal } from '../Entity';
import config from "config";

const LastReceivedData = ({currentMeasurements, entity, showPrimaryGraph}) =>  {
  let primaryDeviceData = <span/>;
  if (currentMeasurements?.length > 0) {
    let primaryMeasurements = currentMeasurements
        .filter(data => data.endTime == null && data.lastReceivedData?.deviceDataType?.primary);
    if (primaryMeasurements.length == 0) {
      primaryMeasurements = currentMeasurements.filter(data => data.endTime == null);
    }

    primaryDeviceData = primaryMeasurements
        .sort((entryA, entryB) => entryA.lastReceivedData?.deviceDataType?.displayOrder - entryB.lastReceivedData?.deviceDataType?.displayOrder)
        .map((displayData, index) => {
          let lastReceivedData = displayData.lastReceivedData;
          if (lastReceivedData?.numericValue != null) {
              lastReceivedData = { ...lastReceivedData, numericValue: DeviceDataOverrideService.getOverrideFunctionForDeviceTypeToken(lastReceivedData.token)(lastReceivedData.numericValue) };
          }
          return (
            <div key={index} className='inline-measurement'>
              <DataTypeDisplayValue 
                value={ lastReceivedData } 
                deviceTypeToken={entity.primaryDeviceTypeToken} 
                displayLabel={true} 
                measureName={displayData.originatingMeasureName}
              />
              <a href="javascript:void(0)"
                className={ "graphLink ddt_" + lastReceivedData.deviceDataType.token }
                onClick={() => showPrimaryGraph(entity, displayData)}>
                <FontAwesomeIcon className="graphLink" icon={faChartArea} size={'lg'}/>
              </a>
            </div>);
          }
        );
  }

  return (<div className="data-row">{primaryDeviceData}</div>);
}

class MonitoringDeviceTable extends React.Component {

  constructor(props) {
    super(props);
    this.fetchData = this.fetchData.bind(this);
    this.datafetched = this.datafetched.bind(this);
    this.makeDatatableRequest = this.makeDatatableRequest.bind(this);

    this.state = {
      localErrorHandler: this.props.localErrorHandler,
      hasError: false,
      entities: this.props.entities,
      deviceGroupIncludeFilter: this.props.deviceGroupIncludeFilter,
      areaFilterIncludeFilter: this.props.areaFilterIncludeFilter,
      statusIncludeFilter: this.props.statusIncludeFilter,
      areaIncludeFilter: this.props.areaIncludeFilter,
      areaFilterOptions : this.props.areaFilterOptions,
      statusFilterOptions: this.props.statusOptions,
      readingFilterOptions: this.props.datatypeOptions,
      readingIncludeFilter: this.props.readingIncludeFilter,
      showDeviceGraphModal: false,
      selectedEntity: null,
      selectedEntityDataType: null,
      data: [],
      pages: null,
      loading: true,
      showEntityDetailModal: false
    };
    this.toggleEntityDetailModal = this.toggleEntityDetailModal.bind(this);
  }

  toggleEntityDetailModal(device, area, alertCount = 0) {
    this.setState({
      alertCount: alertCount,
      detailArea: area,
      entitySerialNumber: device?.serialNumber,
      showEntityDetailModal: !this.state.showEntityDetailModal
    });
  }

  renderUnresolvedEventCount(data) {
    let row = data.row._original;

    if (row.unresolvedEventCount > 0) {
      const found = this.state.entities.find(entity => entity.serialNumber === row.serialNumber);
      const eventPath = `/monitoring/locations/${this.props.grouping.id}/events?filterByDeviceIds=${found?.entityTypeToken === "device" ? found.entityId : ''}&filterByAssetIds=${found?.entityTypeToken === "asset" ? found.entityId : ''}`;
      return <Link to={eventPath}><span className="alertLinkText">{row.unresolvedEventCount}</span></Link>;
    } else {
      return <div>0</div>
    }
  }

  componentDidMount() {

  }

  componentWillReceiveProps(nextProps, nextContext) {
    if ((this.state.deviceGroupIncludeFilter !== nextProps.deviceGroupIncludeFilter) ||
        (this.state.statusIncludeFilter !== nextProps.statusIncludeFilter) ||
        (this.state.areaFilterIncludeFilter !== nextProps.areaFilterIncludeFilter) ||
        (this.state.areaIncludeFilter !== nextProps.areaIncludeFilter)) {
      this.setState({
        entities: nextProps.entities,
        deviceGroupIncludeFilter: nextProps.deviceGroupIncludeFilter,
        statusIncludeFilter: nextProps.statusIncludeFilter,
        areaFilterIncludeFilter: nextProps.areaFilterIncludeFilter,
        areaIncludeFilter: nextProps.areaIncludeFilter
      }, () => {
        if (this.refs.devicesTable) {
          this.fetchData(this.state,null);
        }
      });
    }
  }

  makeDatatableRequest(data, callback, settings) {
    const { deviceGroupIncludeFilter } = this.props;
    const filteredEntities = this.state.entities.filter(device => {
      if (deviceGroupIncludeFilter) {
        return deviceGroupIncludeFilter.includes(device.deviceGrouping.deviceGroup.id);
      } else {
        return true;
      }
    }).filter(device => {
      if (this.state.areaIncludeFilter) {
        return (device.tags.filter(tag => tag.tagType.token === 'area').length === 0 && (this.state.areaIncludeFilter.indexOf(-1) != -1)) ||
               device.tags.find(deviceTag => this.state.areaIncludeFilter.find(areaId => areaId === deviceTag.id));
      } else {
        return true;
      }
    }).filter(device => {
      if (this.state.statusIncludeFilter) {
        return device.thresholdsExceeded.find(threshold => this.state.statusIncludeFilter.find(thresholdId => thresholdId === threshold.id)) ||
            (this.state.statusIncludeFilter.includes(-1) && device.thresholdsExceeded.length === 0);
      } else {
        return true;
      }
    }).filter(device => {
      if (this.state.searchValue) {
        return device.displayName.toLowerCase().includes(this.state.searchValue.toLowerCase()) || device.serialNumber.toLowerCase().includes(this.state.searchValue.toLowerCase())
      } else {
        return true;
      }
    }).filter(device => {
      if (this.state.readingIncludeFilter) {
        let data = device.deviceLastReceivedData.filter(data => data.deviceDataType.primary)
        return device.deviceLastReceivedData.find(data => this.state.readingIncludeFilter.find(datatypeId => datatypeId === data.deviceDataType.id)) ||
            (this.state.readingIncludeFilter.includes(-1) && data.length === 0);
      } else {
        return true;
      }
    }).filter(device => {
      if (this.state.filterDate) {
        if (device.lastUpdatedAt != null && moment(this.state.filterDate).dayOfYear() === moment(device.lastUpdatedAt).dayOfYear() && moment(this.state.filterDate).year() === moment(device.lastUpdatedAt).year()) {
          return true
        }
        return false
      } else {
        return true;
      }
    });

    callback({
      data: filteredEntities,
      recordsTotal: filteredEntities.length,
      recordsFiltered: filteredEntities.length
    });
  }

  datafetched(res) {
    let size = this.refs.devicesTable ? this.refs.devicesTable.state.pageSize : 10;
    let page = this.refs.devicesTable ? this.refs.devicesTable.state.page : 0;
    this.setState({
      data: res.data,
      pages: Math.ceil(res.recordsTotal / size),
      page: page,
      pageSize: size,
      loading: false
    });
  }

  fetchData(state, instance) {
    this.setState({
      loading: true
    });
    this.makeDatatableRequest(state, this.datafetched, null);
  }

  renderDisplayName(data) {
    let tag = data.original.tags.filter(tag => tag.tagType && tag.tagType.token === 'area')[0]
    return <div className = "deviceName" onClick = {this.toggleEntityDetailModal.bind(this,data.original,tag,data.original.unresolvedEventCount)} title={data.row._original.serialNumber}>{data.original.displayName}</div>;
  }

  renderTime(data) {
    if (data?.value) {
      let date = TimeFormattingService.renderDate(data.value, data.original.deviceGrouping && data.original.deviceGrouping.timezone ? data.original.deviceGrouping.timezone : null);
      let time = TimeFormattingService.renderTime(data.value, data.original.deviceGrouping && data.original.deviceGrouping.timezone ? data.original.deviceGrouping.timezone : null);
      return <span>{date}<br/>{time}</span>;
    } else {
      return <span>No recent data</span>;
    }
  }

  renderArea(data) {
    return (data.original.areaTag ? <span>{data.original.areaTag.name}</span> : <span></span>);
  }
  
  showPrimaryGraph(entity, clickedDDT) {
    this.toggleAddDeviceGraphModal(entity, clickedDDT);
  }
  
  toggleAddDeviceGraphModal(entity, deviceDataType) {
    this.setState({
      selectedEntity: entity,
      selectedEntityDataType: deviceDataType,
      showDeviceGraphModal: !this.state.showDeviceGraphModal
    });
  }

  updateSearchValue(val) {
    this.setState({searchValue: val.target.value, autoFocus: true}, () => {
      this.fetchData(this.refs.devicesTable && this.refs.devicesTable.state ? this.refs.devicesTable.state : null);
    });
  }

  renderLastReceivedData(data) {
    let entity = data.row._original;
    return (<div>
        <LastReceivedData
          entity={entity}
          currentMeasurements={entity.currentMeasurements}
          isMobile={false}
          showPrimaryGraph={this.showPrimaryGraph.bind(this)}
        />
      </div>);
  }

  renderDeviceStatus(data) {
    let row = data.row._original;

    let alertState = '';
    if (row.statusToken === 'active' && row.thresholdsExceeded && row.thresholdsExceeded.length > 0) {
      let firstThresholdExceeded = row.thresholdsExceeded[0];
      alertState = <div style={{'paddingLeft':30 + 'px', 'paddingTop':10 + 'px'}}><strong>{firstThresholdExceeded.name}</strong></div>;
    }

    return <div><EntityIcon width={'24'} height={'24'} entity={row} />&nbsp;{ i18next.t(`device-statuses.${row.statusToken}`) }{alertState}</div>;
  }

  updateStatusFilterValue(newOptions) {
    const selectedOptions = newOptions.filter(status => status.selected);
    let statusFilterLabel;

    if (selectedOptions.length === 0) {
      statusFilterLabel = i18next.t('show-none');
    } else if (selectedOptions.length === 1) {
      statusFilterLabel = selectedOptions[0].name;
    } else if (selectedOptions.length < newOptions.length) {
      statusFilterLabel = i18next.t('show-some');
    } else {
      statusFilterLabel = i18next.t('show-all');
    }

    this.setState({
      statusFilterOptions: newOptions,
      statusIncludeFilter: selectedOptions.map(status => status.id),
      statusFilterLabel
    }, () => {
      this.fetchData(this.refs.devicesTable && this.refs.devicesTable.state ? this.refs.devicesTable.state : null);
    });
  }

  updateAreaFilterValue(newOptions) {
    const selectedOptions = newOptions.filter(area => area.selected);
    let areaFilterLabel;

    if (selectedOptions.length === 0) {
      areaFilterLabel = i18next.t('show-none');
    } else if (selectedOptions.length === 1) {
      areaFilterLabel = selectedOptions[0].name;
    } else if (selectedOptions.length < newOptions.length) {
      areaFilterLabel = i18next.t('show-some');
    } else {
      areaFilterLabel = i18next.t('show-all');
    }

    this.setState({
      areaFilterOptions: newOptions,
      areaIncludeFilter: selectedOptions.map(area => area.id),
      areaFilterLabel
    }, () => {
      this.fetchData(this.refs.devicesTable && this.refs.devicesTable.state ? this.refs.devicesTable.state : null);
    });
  }

  updateReadingFilterValue(newOptions) {
    const selectedOptions = newOptions.filter(reading => reading.selected);
    let readingFilterLabel;

    if (selectedOptions.length === 0) {
      readingFilterLabel = i18next.t('show-none');
    } else if (selectedOptions.length === 1) {
      readingFilterLabel = selectedOptions[0].name;
    } else if (selectedOptions.length < newOptions.length) {
      readingFilterLabel = i18next.t('show-some');
    } else {
      readingFilterLabel = i18next.t('show-all');
    }

    this.setState({
      readingFilterOptions: newOptions,
      readingIncludeFilter: selectedOptions.map(reading => reading.id),
      readingFilterLabel
    }, () => {
      this.fetchData(this.refs.devicesTable && this.refs.devicesTable.state ? this.refs.devicesTable.state : null);
    });
  }

  handleDateChange(newDate) {
    this.setState({
      filterDate: newDate
    }, () => {
      this.fetchData(this.refs.devicesTable && this.refs.devicesTable.state ? this.refs.devicesTable.state : null);
    });
  }

  clearDate() {
    this.setState({
      filterDate: ''
    }, () => {
      this.fetchData(this.refs.devicesTable && this.refs.devicesTable.state ? this.refs.devicesTable.state : null);
    });
  }

  render() {
    const { data, loading } = this.state;

    const statusPopover = (
        <Popover className="filter-map-cat-selection filter-map-popover" id="cri-selection-popover" title={ i18next.t('pages.devices.status') }>
          <MultiRowSelection options={this.state.statusFilterOptions} onApplyFilters={this.updateStatusFilterValue.bind(this)} />
        </Popover>
    );

    const areaPopover = (
      <Popover className="filter-map-cat-selection filter-map-popover" id="area-selection-popover" title={ i18next.t('pages.devices.area') }>
        <MultiRowSelection options={this.state.areaFilterOptions} onApplyFilters={this.updateAreaFilterValue.bind(this)} />
      </Popover>
    );

    const readingPopover = (
      <Popover className="filter-map-cat-selection filter-map-popover" id="reading-selection-popover" title={ i18next.t('pages.devices.reading') }>
        <MultiRowSelection options={this.state.readingFilterOptions} onApplyFilters={this.updateReadingFilterValue.bind(this)} />
      </Popover>
    );

    var geoValue = null;
    var geoError = null;

    if (this.state.selectedEntityDataType) {
      const dataType = this.state.selectedEntityDataType;
      if (dataType.token == "geo_lat_lon" || (dataType.deviceDataClassification && dataType.deviceDataClassification.token == "geo_position")) {
        if (dataType && dataType.complexValue && dataType.complexValue.latitude && dataType.complexValue.longitude) {
            geoValue = dataType.complexValue;
        } else {
            geoError = "No current value.";
        }
      }
    }

    return (
    <div>
      <div>
        <ScrollModule/>
        <ScrollArea
            speed={ 0.8 }
            className="scroll-container"
            contentClassName="scrollable-content"
            horizontal={ true } >
          <div className = "monitoring-devices-table">
            <div className="react-table-custom">
                <ReactTable
                  className="-striped -highlight"
                  ref="devicesTable"
                  data={data}
                  loading={loading} // Display the loading overlay when we need it
                  onFetchData={this.fetchData} // Request new data when things change
                  showPaginationTop
                  columns={[
                              {
                                Header: i18next.t('table-headers.asset'),
                                accessor: "displayName",
                                minResizeWidth: 140,
                                Cell: row => (this.renderDisplayName(row)),
                                sortMethod: (a, b) => {
                                  return a.localeCompare(b);
                                },
                                sortable: true,
                                filterable: true,
                                  Filter: <div className="filter">
                                  <input
                                    style={{width: "100%", margin:"0 auto"}}
                                    value = {this.state.searchValue}
                                    onChange={this.updateSearchValue.bind(this)}
                                    type="text"
                                    name="search"
                                    placeholder={ i18next.t('form-labels.search-by-name-or-serial') }
                                    className="table-search"
                                    autoComplete="off"
                                  />
                                </div>
                              },
                              {
                                Header: i18next.t('table-headers.current-status'),
                                accessor: "deviceStatus",
                                Cell: row => (this.renderDeviceStatus(row)),
                                sortable: true,
                                sortMethod: (a, b) => {return a.id - b.id},
                                minResizeWidth: 140,
                                filterable: true,
                                  Filter: props => <div className="filter select-filter">
                                    <OverlayTrigger trigger="click" rootClose placement="bottom" overlay={ statusPopover }>
                                      <a className="table-filter-button status-filter">{this.state.statusFilterLabel ? this.state.statusFilterLabel : i18next.t('show-all') }</a>
                                    </OverlayTrigger>
                                </div>
                              },
                              {
                                Header: i18next.t('table-headers.reading'),
                                accessor: "lastReceivedData",
                                minResizeWidth: 150,
                                width: 200,
                                getProps: (state, rowInfo, column) => {
                                  return {
                                      style: {
                                          textAlign: 'right',
                                      },
                                  };
                                },
                                Cell: row => (this.renderLastReceivedData(row)),
                                sortable: false,
                                filterable: true,
                                  Filter: props => <div className="filter select-filter">
                                    <OverlayTrigger trigger="click" rootClose placement="bottom" overlay={ readingPopover }>
                                      <a className="table-filter-button reading-filter">{this.state.readingFilterLabel ? this.state.readingFilterLabel : i18next.t('show-all') }</a>
                                    </OverlayTrigger>
                                  </div>
                              },
                              {
                                Header: i18next.t('table-headers.date'),
                                accessor: "lastUpdatedAt",
                                minResizeWidth: 140,
                                width: 140,
                                Cell: row => (this.renderTime(row)),
                                sortable: true,
                                getHeaderProps: (state, rowInfo, column) => {
                                  return {
                                      style: {
                                          overflow: 'visible',
                                      },
                                  };
                                },
                                filterable: true,
                                  Filter: props => 
                                  <div className={`filter time-filter${this.state.filterDate != null && this.state.filterDate != "" ? " has-value" : " no-value"}`}>
                                    <DatePickerInput
                                      clickUnselectsDay = {true}
                                      onDayChange={this.handleDateChange.bind(this)}
                                      input={{value: this.state.filterDate}}
                                      meta={{}}
                                      clearDate={this.clearDate.bind(this)}
                                    />
                                  </div>
                              },
                              {
                                Header: i18next.t('table-headers.area'),
                                accessor: "tags",
                                minResizeWidth: 160,
                                Cell: row => (this.renderArea(row)),
                                sortMethod: (a, b) => {
                                  let name1 =  a.filter(tag => tag.tagType && tag.tagType.token === 'area').map(tag => tag.name)[0];
                                  let name2 =  b.filter(tag => tag.tagType && tag.tagType.token === 'area').map(tag => tag.name)[0];
                                  if (name1 == null) {
                                    return -1;
                                  } else if (name2 == null) {
                                    return 1;
                                  }
                                  return name1 < name2 ? 1 : -1;
                                },
                                sortable: true,
                                filterable: true,
                                  Filter: props => <div className="filter select-filter">
                                    <OverlayTrigger trigger="click" rootClose placement="bottom" overlay={ areaPopover }>
                                      <a className="table-filter-button area-filter">{this.state.areaFilterLabel ? this.state.areaFilterLabel : i18next.t('show-all') }</a>
                                    </OverlayTrigger>
                                  </div>
                              },
                              {
                                Header: i18next.t('table-headers.events'),
                                Cell: row => (this.renderUnresolvedEventCount(row)),
                                accessor: "unresolvedEventCount",
                                sortable: true,
                                minResizeWidth: 100,
                                width: 100
                              }
                            ]}
                />
            </div>
          </div>
        </ScrollArea>

        <Modal show={this.state.showDeviceGraphModal} onHide={() => { this.toggleAddDeviceGraphModal(null, null); }}>
          <Modal.Header closeButton>
            <Modal.Title>
              {
                this.state.selectedEntity && this.state.selectedEntityDataType ?
                    <span>
                      <img src={`${config.WEB_BASE_URL}/images/icon/themes/${window.globalBrand}/charts.svg`} alt={ i18next.t('data-chart') } /> 
                      &nbsp; 
                      {this.state.selectedEntity.displayName} {(this.state.selectedEntityDataType.originatingMeasureName) + ' - ' + i18next.t(`device-data-types.${this.state.selectedEntityDataType.originatingDeviceDataTypeToken}`) } 
                    </span>
                    : null
              }
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="device-chart-modal">
            {
              this.state.selectedEntity && this.state.selectedEntityDataType ? (
                this.state.selectedEntityDataType.originatingDeviceDataTypeToken == "geo_lat_lon" || this.state.selectedEntityDataType.lastReceivedData?.deviceDataClassification?.token == "geo_position" ?
                  (geoValue && <GeoValueMap geoValue={geoValue} /> || geoError && <span>{geoError}</span>)
                  :
                  <DeviceViewDetailsGraph
                      dataType={this.state.selectedEntityDataType.lastReceivedData?.deviceDataType}
                      singleSelectedMeasurement={this.state.selectedEntityDataType}
                      entityTypeToken={this.state.selectedEntity.entityTypeToken} 
                      entityId={this.state.selectedEntity.entityId}
                      timezone={this.state.selectedEntity.businessGroup?.timezone}
                  />
              ) : null
            }
          </Modal.Body>
        </Modal>

        <EntityDetailModal
          isMobile={this.props.isMobile}
          entitySerialNumber={this.state.entitySerialNumber}
          show={this.state.showEntityDetailModal}
          onHide={this.toggleEntityDetailModal}
        />
      </div>
    </div>
    );
  }
}

const GeoValueMap = ({ geoValue }) => {
    if (geoValue == null) {
        return <div>Location unavailable</div>;
    } else {
        return (
            <Map id="mapId" center={[geoValue.latitude, geoValue.longitude]} zoom={12}>
                <TileLayer attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors' url="http://{s}.tile.osm.org/{z}/{x}/{y}.png" />
                <Marker position={[geoValue.latitude, geoValue.longitude]} />
            </Map>
        );
    }
};

GeoValueMap.propTypes = {
    geoValue: PropTypes.object.isRequired,
};

export default MonitoringDeviceTable;
